export const locales = ['en-US', 'en-PS', 'fr_FR', 'de_DE', 'ja_JA'];
